const MEMORY_PRELOADED_ASSETS = new Set()

let preloadQueue = Promise.resolve()

const addToPreloadQueue = asset => {
  preloadQueue = preloadQueue.then(() => {
    return new Promise((resolve, reject) => {
      if (MEMORY_PRELOADED_ASSETS.has(asset.url)) {
        resolve()
        return
      }

      if (asset.loadretry > 2) {
        resolve()
        return
      }

      if (asset.mime.includes('image')) {
        const img = new Image()
        img.src = asset.formats?.screenWeb ? asset.formats.screenWeb.url : asset.url
        img.onload = () => {
          MEMORY_PRELOADED_ASSETS.add(img.src)
          resolve()
        }
        img.onerror = () => {
          asset.loadretry = (asset.loadretry || 0) + 1
          reject(new Error('Load KO'))
        }
        return
      }

      if (asset.mime.includes('video')) {
        fetch(asset.url)
          .then(res => res.blob())
          .then(blob => URL.createObjectURL(blob))
          .then(url => {
            const video = document.createElement('video')
            video.src = url
            MEMORY_PRELOADED_ASSETS.add(asset.url)
            asset.preloadedurl = url
            resolve()
          })
          .catch(e => {
            asset.loadretry = (asset.loadretry || 0) + 1
            reject(new Error('Load KO'))
          })
        return
      }

      reject(new Error('Not a valid asset mime type'))
    }).catch(() => {
      addToPreloadQueue(asset)
    })
  })
}

const usePreloadMedia = screenContent => {
  const assets = deepIterateScreenContent(screenContent, [])
  for (const asset of assets) {
    addToPreloadQueue(asset)
  }
}

const deepIterateScreenContent = (obj, bucket) => {
  if (obj !== Object(obj)) {
    return bucket
  }

  const mime = obj.mime ?? null
  if (mime && (mime.includes('video') || mime.includes('image'))) {
    bucket.push(obj)
    return bucket
  }

  const keys = Object.keys(obj)
  for (let i = 0; i < keys.length; i++) {
    deepIterateScreenContent(obj[keys[i]], bucket)
  }
  return bucket
}

export default usePreloadMedia
